import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map, Subscription} from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { Brand } from './../../../shared/models/brand.model';
import { FileUploadsModalComponent } from './../../../manager/file-uploads-modal/file-uploads-modal.component';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';

// npm to valiate Australian ABN --  
//::@https://github.com/wojtekmaj/is-valid-abn#readme
import isValidABN from 'is-valid-abn'
import { MyobApiCustomerClientSyncToolsWidgetComponent } from '../../myob/myob-api-customer-client-sync-tools-widget/myob-api-customer-client-sync-tools-widget.component';
import { MyobApiCustomerSupplierSyncToolsWidgetComponent } from '../../myob/myob-api-customer-supplier-sync-tools-widget/myob-api-customer-supplier-sync-tools-widget.component';

@Component({
  selector: 'app-brand-create-widget',
  templateUrl: './brand-create-widget.component.html',
  styleUrls: ['./brand-create-widget.component.css']
})
export class BrandCreateWidgetComponent implements OnInit, OnChanges {

  // setup as observable?
  @Input() item_id?: Observable<any[]>; // impliments on changes.
  @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'side'; // side | abstract | full

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

  @ViewChild('brandForm') form: any; //  access form vars
  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;

  job: any;
  job_id;
 brand_id: any;
 model: Brand;
 baseUploadURL: string;
 brand_types: any;
 brand: any;
 filenameselected: any;
 stripped: any;
  get_latest_brand_id: any;
  DialogObj: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  is_brand_abn_valid: any;
  brand_data: Object;
  new_brand_model: any;
  ABN_website_URL: string;


user_ui_layout_id_Options = [
  { value: '1', label: 'DEFAULT: Client Job Submission' },
  { value: '2', label: 'Advanced: Client Job Submission - subject(s) appened to special instuctions' }
];
  new_user_data: any;
  new_inserted_user_id: any;

 constructor(
   private http: HttpClient, private _demoService: DemoService,
   private route: ActivatedRoute, public toastr: HotToastService,
    vcr: ViewContainerRef, private router: Router,
    public HttpClient:HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    public myobApi_CTW: MyobApiCustomerClientSyncToolsWidgetComponent,
    public myobApi_STW: MyobApiCustomerSupplierSyncToolsWidgetComponent,
 ) { 


  
  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
 
       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


           // MYOB/ABN LOOKUP SERVCE WEVSIUTE -- Poperway to include an IFRAM angular sucrutt bypass
this.ABN_website_URL = 'https://abr.business.gov.au/';

this.gfunc.myobChecker();


  }

  // check for changes. to load data.
  ngOnChanges(changes) {
   if (changes.item_id) {
     // deal with asynchronous Observable result
     this.brand_id = changes.item_id.currentValue;
     this.baseUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/' + this.brand_id; // no trailing slash
     this.model = new Brand();
     this.model.create_primary_contact = 1;
     // Set some defaults
     // this.model.is_active = 'Y';
     this.getBrandTypesNoOwner();
     this.getBrandById(this.brand_id);
   }
 }


 ngOnInit() {
   // load without being sent the ID.
 // this.getBrandTypes();
 }

 // Functions
 getBrandTypes() {
   this._demoService.getBrandBrandTypes().subscribe(
      data => { this.brand_types = data; },
      err => console.error(err),
      // () => console.log('done loading candidate for update')
    );
  }

       
  getBrandTypesNoOwner() {
    this._demoService.getBrandBrandTypesNoOwner().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }
  

  getBrandById(brand_id) {
   this._demoService.getBrandById(brand_id).subscribe(
     data => { this.brand = data; },
     err => console.error(err),
     () => console.log('done loading company')
   );
 }


// need to change this below
 editBrand(model){
  // model.job_id = this.job_id;
   this._demoService.updateBrand(model).subscribe(
     data => {  // this.trace_candidate_update = data;
       // refresh the list
      // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
     this.toastr.success('Company Updated');
    // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
     },
     error => {
      // console.error('Error saving Event!');
       this.toastr.error('Error Updating Brand');
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
 );}




  // MODAL view a component
  openModalWithComponent() {
   const initialState = {
     title: 'Upload Image / Photo',
     item_id: 1010,
     brand_id: this.brand_id,
     size: 'lg',
     backdrop: true,
     IgnoreBackdropClick: false,
   };
   this.bsModalRef = this.modalService.show(FileUploadsModalComponent, {initialState});
   // sets the var to in the component model
   this.bsModalRef.content.brand_id = this.brand_id;
   this.bsModalRef.content.item_id = this.brand_id;
   this.bsModalRef.content.closeBtnName = 'Close';
   this.bsModalRef.content.brand_model = this.brand;
   // subscribed to the emitter and get the value.
   this.bsModalRef.content.action.take(1).subscribe((value) => {
 // console.log(value); // here you will get the value of the file
 // Remove the "uploads/" part from the filename.
 this.filenameselected = value;
 this.stripped = this.filenameselected.replace('uploads/', '');
 // this.model.main_image = this.stripped; // works for simple add not update.
 // console.log(this.stripped);
 // console.log(this.model);
 this.form.logo = this.stripped;
 // this.form.reset();
 // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
 this.form.controls['logo'].patchValue(this.form.logo);
 
 });

 }





 createBrandPrimary(model) {

  // 2023 Feb Set these as defaults to stop inconsistancies and only keep better data recordes
model.updated = this.gfunc.today_ISO;
model.created = this.gfunc.today_ISO;
model.created_by = this.gfunc.sessionUserId;
model.updated_by = this.gfunc.sessionUserId;
// replace '&' from notes // needs if undefined.
// if(model.brand_notes){
// model.brand_notes =  model.brand_notes.replace('&', 'and') // replaces with normal text to stop templates from breaking.
// }

// Now a choice in the forn
// model.sync_with_myob = 0; // just sets this so no more nulls are created.

// model.accounts_email_address = model.email; // Now sets the accounts email ass default

          this._demoService.createBrandPrimary(model).subscribe(

              data => {  this.get_latest_brand_id = data; // this is the retuned json upon creation.

 
 
 
        // to to then quick run the brand client code update so that the code exists in the system on creation. 
        this.gfunc.createBrandClientCode(this.get_latest_brand_id.last_insert_id)


    




        // PHP api hadles the logic and new user insert.
        // :: Insert Log file
        model.brand_id = this.get_latest_brand_id.last_insert_id;

   



        this.gfunc.insertLog_CreateCompany(model); // hadled in the global functions file.
                this.onOpenDialog(model);
                this.traceAddNotice();
              




        if(model.create_primary_contact == 1){
          //  this.toastr.info('Starting Send.')
             
            
               setTimeout(() => {  
              this.getUsersByUsernameEmail(model);
                 // new trigge and automation so I can run some loops. --- moved to functinos and buttons

            }, 3000);  
           
           
           setTimeout(() => {  
            
                 
                            if(model.send_welcome_email){

                            // I Need to ge the last user ID that was inserted... SO LOOUP BY USERNAME(firstname_surname) and email_address       
                            model.last_insert_id = this.new_inserted_user_id;
                            model.brand_report_user_id = this.new_inserted_user_id; // Send to the new user in automations "brand_report_user or new user"
                           // required for new automation type variables to render as report user.
                            model.custom_run = 'user_welcome_email';
                          // model.created_by = this.gfunc.sessionUserId;


                                console.log('test new user ID:' + this.new_inserted_user_id + ' b: ' + this.new_user_data[0].user_id)

                             let new_model = model;
                                
                            this.gfunc.insertLog_CreateUserSendWelcomeEmail(new_model)
                            this.toastr.success('Welcome Email Sent.')

                            }

                            

             }, 10000);  
             
             
           
            }




       
        





              //  this.router.navigate(['../../companies'], { relativeTo: this.route });

                //  return true;
              },
              error => {
                this.toastr.error('Adding Company Failed :: Please try again!');
                console.log(error.error)
                //return console.log(error);
              }
          );

  }

  traceAddNotice() {
    this.toastr.info('Company Added');
  };


      getUsersByUsernameEmail(model) {
        this._demoService.getUsersByUsernameEmail(model).subscribe(
          data => { this.new_user_data = data;

          let res = data[0]
           // console.log("Done loadng USER");
           // console.log(this.users);
          // this.users_updated = data;
          this.new_inserted_user_id = res.user_id;

          },
          error => {
            console.error('Error Loading User!');
          return console.log(error);
          }
        ); }




// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}




// syncfusion dialog simple sample
public onOpenDialog = function(event: any): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Create Company',
    content: 'Successfully Created Company and Data Saved. You may continue.',
    okButton: {  text: 'Ok', click: this.okClick.bind(this) },
  // cancelButton: {  text: '.', click: this.cancelClick.bind(this) },
  cancelButton: {  text: '.', click: this.okClick.bind(this) },
  showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
public okClick(): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.JSON_job);
// this.createJobSubjectsMultiple(this.newSubject);
 this.DialogObj.hide();
console.log('Base Route: ' + this.gfunc.current_base_route);
 if (this.gfunc.current_base_route === '/admin/jobs') {
// run a function in parent component
        this.closeParentModel.emit();
  this.router.navigateByUrl('/admin/jobs', {skipLocationChange: true}).then(() =>
  this.router.navigate(['/admin/jobs/create-job/']));
 }
if (this.gfunc.current_base_route === '/admin/brands/company') {
 this.router.navigate(['../../companies'], { relativeTo: this.route });
}

}; // end functiiom

private cancelClick(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
   this.modalRef.hide(); // hide the modal?
}



checkABN(model){
  this.is_brand_abn_valid;
  this.is_brand_abn_valid =  isValidABN(model.abn )
  // this.model = this.model
}






// Do some delays....  and see what happends abit 2 secpmds betwen each...

approveSaveAndSyncBrand(model){

  // this.updateInvoiceStatus(invoice_model);
  // this.createSubjectInvoicePDF(invoice_model, invoice_model.invoice_id)

  this.toastr.info("Sending + Creating Client Asses + Users if Applicable")
  //  this.createSubjectInvoicePDFAndSend(invoice_model, invoice_model.invoice_id);
  this.createBrandPrimary(model)

  setTimeout(() => {  
    this.toastr.info("Gathering updated Client datas, ready for Sync")
    // this.getInvoice(invoice_model.invoice_id, invoice_model) -- then sync the model... lookup again... barand

    console.log('Inserted Brand Id: ' + this.get_latest_brand_id.last_insert_id)
    this.getBrandAndSync(this.get_latest_brand_id.last_insert_id) // set from retuned brand insert above.

    }, 3500);
  /// Mow Sync the invoice with MYOB. -- link to function through components 

  // setTimeout(() => {  

  //   // Need to lookup invoice status

  //     // Set the same model as above so that the correct invoice details

  //   this.toastr.info("Starting Sync")
  //   // invoice_model = this.invoiceItem // set to updated invoice item above.
 
  
  //   }, 6000);
  
  }

private getBrandAndSync(brand_id) {
  this._demoService.getBrandById(brand_id).subscribe(
    (data) => {
      this.brand_data = data;

      this.new_brand_model = {
        ...data[0],
        sync_with_myob: 1
      }
      

      /// Now run the sync.... for save and send.
      // Clients
      if(this.new_brand_model.brand_type_id == 2){
      this.myobApi_CTW.createMyobCustomerModel(this.new_brand_model);
      }
      // Agents
      if(this.new_brand_model.brand_type_id  == 3){
        this.myobApi_STW.createMyobSupplierModel(this.new_brand_model);
      }

    },
    (err) => console.error(err),
    () => console.log('Brand Loaded.')
  );
}





}


